import { AttackPattern, PatternState } from '../../AttackPattern.js';

/**
 * Echo Cone — the ghost's hostile mirror of Scatter Cannon (Echo Duel, see
 * data/echoBoss.js): two staggered cone volleys aimed at the player's live
 * position. Pellet count scales with the recorded weapon's level.
 */
export class EchoCone extends AttackPattern {
  constructor({ config }) {
    super({ name: 'Echo Cone', telegraphDuration: 0.5, activeDuration: 0.45, minPhase: 0 });
    this.config = config;
  }

  onBegin() {
    this._wavesFired = 0;
    this._fireTimer = 0;
  }

  onActiveTick(dt, boss, player, pool) {
    this._fireTimer -= dt;
    if (this._fireTimer > 0 || this._wavesFired >= 2) return;
    this._fireTimer = 0.3;
    this._wavesFired++;

    const pellets = 6 + Math.floor((this.config.level ?? 1) / 2);
    const baseAngle = Math.atan2(player.y - boss.y, player.x - boss.x);
    const spread = 0.7;
    for (let i = 0; i < pellets; i++) {
      const t = pellets === 1 ? 0 : (i / (pellets - 1)) * 2 - 1;
      const angle = baseAngle + t * (spread / 2);
      pool.fire({
        x: boss.x,
        y: boss.y,
        vx: Math.cos(angle) * this.config.speed,
        vy: Math.sin(angle) * this.config.speed,
        radius: 2.5,
        damage: this.config.damage,
        color: '#f4e04d',
        lifetime: 3.5,
      });
    }
  }

  getVisual(boss) {
    if (this.state !== PatternState.TELEGRAPH) return null;
    return { kind: 'ringPulse', x: boss.x, y: boss.y, t: 1 - this._timer / this.telegraphDuration };
  }
}
